
import { Component, OnInit, OnDestroy, inject } from '@angular/core'
import { UserService } from '@aifs-shared/user/user.service'
import { TrackerTaskComponent } from '@aifs-shared/tracker/tracker-task.component';
import { ITaskProvider } from '@aifs-shared/tracker/task-provider';

@Component({
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent extends TrackerTaskComponent implements OnInit, OnDestroy, ITaskProvider {

    private userService = inject(UserService);

    constructor() {
        super();
        this.requiresTask = false;
    }

    override ngOnInit() {
        super.ngOnInit();
        this.title = "Contact Us";

        var u = this.userService.isLoggedIn();
        if (!u) return;

        switch (this.userService.userCountry()) {
            case "AU":
                this.displayAU = true;
                break;
            case "DE":
            case "AT":
            case "CH":
                this.displayDE = true;
                break;
            case "NZ":
                this.displayNZ = true;
                this.showUKAddress = true;
                break;
            case "PL":
                this.displayPL = true;
                this.showUKAddress = false;
                break;
            case "RU":
                this.displayRU = true;
                this.showUKAddress = true;
                break;
            case "UA":
                this.displayUA = true;
                this.showUKAddress = true;
                break;
            default:
                this.displayUK = true;
                this.showUKAddress = true;
                break;
        }

        // console.info(`Show UK ${this.showUKAddress}, is in UK: ${this.displayUK}`);
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
    }

    title: string = '';
    displayAU: boolean = false;
    displayDE: boolean = false;
    displayUK: boolean = true;
    displayNZ: boolean = false;
    displayPL: boolean = false;
    displayUA: boolean = false;
    displayRU: boolean = false;

    showUKAddress: boolean = true;
}
